import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FormTextarea } from "shards-react";
import { strings } from "../localization";


function FoodInstructionDialog({ showModal, setShowModal, note, itemName }) {
  return (
    <Modal
      show={showModal}
      onHide={() => {
        setShowModal(false);
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable={true}
    >
      <Modal.Header closeButton>
        <h5 className="p-0 m-0">{itemName}</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <FormTextarea
            value={note}
            placeHolder={strings.enter_food_instruction}
            className="note"
            size="lg"
            rows="4"
            readOnly={true}
            style={{
              color: "#292929",
              fontSize: "16px",
              fontWeight: "400",
              textDecoration: "none",
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default FoodInstructionDialog;
